import { motion, AnimatePresence } from 'framer-motion'
import { useState, useEffect } from 'react'
import { PhoneCall, X, Calendar } from 'lucide-react'

const FloatingCTA = () => {
  const [isVisible, setIsVisible] = useState(false)
  const [isExpanded, setIsExpanded] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      // Show button after scrolling 300px
      setIsVisible(window.scrollY > 300)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const handleConsultation = () => {
    // Navigate to contact page or open consultation modal
    window.location.href = '/consultation'
  }

  const handleWhatsApp = () => {
    window.open('https://wa.me/355XXXXXXXXX', '_blank')
  }

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0, opacity: 0 }}
          className="fixed bottom-6 right-6 z-50"
        >
          {/* Expanded Menu */}
          <AnimatePresence>
            {isExpanded && (
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 20 }}
                className="absolute bottom-20 right-0 bg-gradient-to-br from-bronze-900/95 to-bronze-950/95 backdrop-blur-2xl rounded-2xl border border-gold-400/30 shadow-2xl p-4 w-64"
              >
                <div className="space-y-2">
                  {/* Consultation Button */}
                  <motion.button
                    whileHover={{ x: 5 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={handleConsultation}
                    className="w-full flex items-center gap-3 px-4 py-3 bg-gradient-gold text-white rounded-xl font-semibold shadow-lg hover:shadow-gold-400/50 transition-all"
                  >
                    <Calendar className="w-5 h-5" />
                    <div className="text-left">
                      <div className="text-sm">Konsultim Falas</div>
                      <div className="text-xs opacity-80">30 minuta</div>
                    </div>
                  </motion.button>

                  {/* WhatsApp Button */}
                  <motion.button
                    whileHover={{ x: 5 }}
                    whileTap={{ scale: 0.95 }}
                    onClick={handleWhatsApp}
                    className="w-full flex items-center gap-3 px-4 py-3 bg-green-500/20 text-green-400 border border-green-500/30 rounded-xl font-semibold hover:bg-green-500/30 transition-all"
                  >
                    <PhoneCall className="w-5 h-5" />
                    <div className="text-left">
                      <div className="text-sm">WhatsApp</div>
                      <div className="text-xs opacity-80">Chat live</div>
                    </div>
                  </motion.button>
                </div>
              </motion.div>
            )}
          </AnimatePresence>

          {/* Main Button */}
          <motion.button
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.9 }}
            onClick={() => setIsExpanded(!isExpanded)}
            className="relative group"
          >
            {/* Pulsing Ring */}
            <motion.div
              animate={{ 
                scale: [1, 1.3, 1],
                opacity: [0.5, 0, 0.5]
              }}
              transition={{ duration: 2, repeat: Infinity }}
              className="absolute inset-0 bg-gradient-gold rounded-full blur-md"
            />
            
            {/* Button */}
            <div className="relative w-16 h-16 bg-gradient-gold rounded-full shadow-2xl flex items-center justify-center">
              <AnimatePresence mode="wait">
                {isExpanded ? (
                  <motion.div
                    key="close"
                    initial={{ rotate: -90, opacity: 0 }}
                    animate={{ rotate: 0, opacity: 1 }}
                    exit={{ rotate: 90, opacity: 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    <X className="w-7 h-7 text-white" />
                  </motion.div>
                ) : (
                  <motion.div
                    key="phone"
                    initial={{ rotate: -90, opacity: 0 }}
                    animate={{ rotate: 0, opacity: 1 }}
                    exit={{ rotate: 90, opacity: 0 }}
                    transition={{ duration: 0.2 }}
                  >
                    <PhoneCall className="w-7 h-7 text-white" />
                  </motion.div>
                )}
              </AnimatePresence>
            </div>

            {/* Badge */}
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.5, type: "spring" }}
              className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 rounded-full border-2 border-white flex items-center justify-center"
            >
              <motion.div
                animate={{ scale: [1, 1.2, 1] }}
                transition={{ duration: 1, repeat: Infinity }}
                className="w-2 h-2 bg-white rounded-full"
              />
            </motion.div>
          </motion.button>

          {/* Tooltip */}
          {!isExpanded && (
            <motion.div
              initial={{ opacity: 0, x: 10 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 1 }}
              className="absolute right-20 top-1/2 -translate-y-1/2 bg-bronze-900/95 backdrop-blur-xl px-4 py-2 rounded-lg border border-gold-400/30 whitespace-nowrap pointer-events-none"
            >
              <p className="text-beige-200 text-sm font-semibold">
                Na kontakto tani! 📞
              </p>
              <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1/2 rotate-45 w-2 h-2 bg-bronze-900 border-r border-t border-gold-400/30" />
            </motion.div>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  )
}

export default FloatingCTA
